const CATEGORIES_URL = process.env.API_URL + '/category/';

const getCategories = (context) => {
  return context.$http.get(CATEGORIES_URL);
};

const deleteCategory = (context, id) => {
  return context.$http.delete(CATEGORIES_URL, {params: {id: id}});
};

const createCategory = (context, category) => {
  return context.$http.post(CATEGORIES_URL, category);
};

const updateCategory = (context, category) => {
  return context.$http.put(CATEGORIES_URL, category);
};

export default {
  getCategories,
  deleteCategory,
  createCategory,
  updateCategory
};



// WEBPACK FOOTER //
// ./src/api/category/categoryHttp.js